export default __webpack_public_path__ + "static/media/csv.93542043.webp";